<svg 
  class="icon-home"
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="outline ? 'none' : color"
  viewBox="0 0 20 20"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    [attr.stroke]="outline ? color : 'none'"
    [attr.stroke-width]="outline ? '1.5' : '0'"
    d="M3.16394 17.6694V7.4152L9.99998 2.28583L16.836 7.41354V17.6694H11.7064V11.6269H8.29352V17.6694H3.16394Z"
  />
</svg>